class LiferayHelper {
  getPortalURL() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getPortalURL();
    }
    return window.location.origin;
  }

  getScopeGroupId() {
    if (typeof window !== 'undefined' && window.Liferay?.ThemeDisplay) {
      return window.Liferay.ThemeDisplay.getScopeGroupId();
    }
    // Fallback to the site ID from your curl example
    return '20118';
  }

  async getAccessToken() {
    try {
      const response = await fetch('/o/tokenService/get-token', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Token request failed: ${response.status} - ${errorText}`);
      }

      const result = await response.json();
      return result?.data?.accessToken || null;
    } catch (error) {
      console.error('Error fetching access token:', error);
      return null;
    }
  }

  async getHeaders() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };

    const token = await this.getAccessToken();
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    return headers;
  }
}

export default LiferayHelper;

